<div class="mt-2">
    <mat-checkbox class="doc-custom-checkbox w-100" [checked]="value" (change)="changedStatus($event)">
        <span class="label">
            <ng-content></ng-content>
        </span>
    </mat-checkbox>
    <mat-hint>
        <doc-form-field-error [parentForm]="parentForm" [controlName]="controlName"></doc-form-field-error>
    </mat-hint>
</div>